module.exports = __webpack_public_path__ + "static/media/jingteshu22.69048949.png";